import { type BasicCheckMerchantsResponse } from '@redteclab/api/clients/bully'

type PickupSlotDayAndTime = {
  pickupDay: string
  pickupStartTime: string
}

export const nowBasicCheckResponseAccessorGetNowFirstPickupSlotDayAndTime = (
  merchantsResponse: BasicCheckMerchantsResponse | undefined,
): PickupSlotDayAndTime | undefined => {
  if (!merchantsResponse?.pickupSlots?.[0]) {
    return undefined
  }

  const [{ pickupDay, pickupStartTime }] = merchantsResponse.pickupSlots

  if (!pickupDay || !pickupStartTime) {
    return undefined
  }

  const [hoursDeliveryStartTime] = pickupStartTime.split(':')

  return {
    pickupDay,
    pickupStartTime: hoursDeliveryStartTime,
  }
}
